"use client";
import { jsx } from "react/jsx-runtime";
import { Suspense, memo, useMemo } from "react";
import { useDispatch } from "../../runtimes/react/hooks/use-dispatch";
import { useUniversalDispatch } from "../../runtimes/react/hooks/use-universal-dispatch";
import { useCacheData } from "../../runtimes/react/hooks/use-cache-data";
import { Page as PageComponent } from "../../components/page";
import {
  pageToRootDocument
} from "../client";
import { registerDocumentsEffect } from "../../state/actions";
function useRegisterPageDocument(pageDocument) {
  const dispatch = useDispatch();
  const rootDocuments = useMemo(
    () => [pageToRootDocument(pageDocument)],
    [pageDocument]
  );
  useUniversalDispatch(dispatch, registerDocumentsEffect, [rootDocuments]);
  return rootDocuments[0];
}
const Page = memo(({ snapshot, metadata = true, ...props }) => {
  if ("runtime" in props) {
    throw new Error(
      `The \`runtime\` prop is no longer supported in the \`@makeswift/runtime\` \`Page\` component as of \`0.15.0\`.
See our docs for more information on what's changed and instructions to migrate: https://docs.makeswift.com/migrations/0.15.0`
    );
  }
  useCacheData(snapshot.cacheData);
  const rootDocument = useRegisterPageDocument(snapshot.document);
  return /* @__PURE__ */ jsx(Suspense, { children: /* @__PURE__ */ jsx(
    PageComponent,
    {
      page: snapshot.document,
      rootDocument,
      metadata
    },
    snapshot.document.data.key
  ) });
});
export {
  Page
};
//# sourceMappingURL=page.js.map